// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { CompleteAttribute } from './CompleteAttribute';
import { EnumAccessModifier } from '../../../../../com/MetaPattern/MDA/MD/Base/EnumAccessModifier';
import { EnumRelationshipType } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';
import { BEEntity } from './BEEntity';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 属性 实体类
 * 属性
 */
export class BEAttribute extends CompleteAttribute {
  /** 访问修饰符 : 访问修饰符 */
  private _accessModifier: EnumAccessModifier;

  /** 设置：访问修饰符 */
  public get accessModifier() {
    return this._accessModifier;
  }

  /** 获取：访问修饰符 */
  public set accessModifier(value: EnumAccessModifier) {
    this._accessModifier = value;
  }

  /** 是否是计算属性 : 是否是计算属性 */
  private _isCalculate: boolean;

  /** 设置：是否是计算属性 */
  public get isCalculate() {
    return this._isCalculate;
  }

  /** 获取：是否是计算属性 */
  public set isCalculate(value: boolean) {
    this._isCalculate = value;
  }

  /** 计算表达式 : 计算表达式，当IsCalculate为true的时候有效 */
  private _calculateExpress: string;

  /** 设置：计算表达式 */
  public get calculateExpress() {
    return this._calculateExpress;
  }

  /** 获取：计算表达式 */
  public set calculateExpress(value: string) {
    this._calculateExpress = value;
  }

  /** 是否是静态 : 是否是静态属性 */
  private _isStatic: boolean;

  /** 设置：是否是静态 */
  public get isStatic() {
    return this._isStatic;
  }

  /** 获取：是否是静态 */
  public set isStatic(value: boolean) {
    this._isStatic = value;
  }

  /** 业务主键 : 业务主键，多个属性同时为true则会设置为联合业务主键 */
  private _isBusinessKey: boolean;

  /** 设置：业务主键 */
  public get isBusinessKey() {
    return this._isBusinessKey;
  }

  /** 获取：业务主键 */
  public set isBusinessKey(value: boolean) {
    this._isBusinessKey = value;
  }

  /** 是否唯一 : 是否唯一，true代表属性的值必须唯一，且不能为空 */
  private _isUnique: boolean;

  /** 设置：是否唯一 */
  public get isUnique() {
    return this._isUnique;
  }

  /** 获取：是否唯一 */
  public set isUnique(value: boolean) {
    this._isUnique = value;
  }

  /** 缺省列名 : 缺省列名 */
  private _defaultColumnName: string;

  /** 设置：缺省列名 */
  public get defaultColumnName() {
    return this._defaultColumnName;
  }

  /** 获取：缺省列名 */
  public set defaultColumnName(value: string) {
    this._defaultColumnName = value;
  }

  /** 是否前端可见 : 是否前端可见，false代表不对前端输出，前端不可见 */
  private _isForFront: boolean;

  /** 设置：是否前端可见 */
  public get isForFront() {
    return this._isForFront;
  }

  /** 获取：是否前端可见 */
  public set isForFront(value: boolean) {
    this._isForFront = value;
  }

  /** 是否是系统属性 : 是否是系统属性，系统预置属性不可编辑 */
  private _isSystem: boolean;

  /** 设置：是否是系统属性 */
  public get isSystem() {
    return this._isSystem;
  }

  /** 获取：是否是系统属性 */
  public set isSystem(value: boolean) {
    this._isSystem = value;
  }

  /** 是否关联属性 : 关联属性是关联线的冗余属性，根据关联线自动进行控制。关联属性仅用于代码生成及UI层，在实体层并不使用，所以只是在实体保存的时候才自动同步。 */
  private _isAssociation: boolean;

  /** 设置：是否关联属性 */
  public get isAssociation() {
    return this._isAssociation;
  }

  /** 获取：是否关联属性 */
  public set isAssociation(value: boolean) {
    this._isAssociation = value;
  }

  /** 是否上传图片 : 是否上传图片，true则数据类型必须设置为string */
  private _isUploadImage: boolean;

  /** 设置：是否上传图片 */
  public get isUploadImage() {
    return this._isUploadImage;
  }

  /** 获取：是否上传图片 */
  public set isUploadImage(value: boolean) {
    this._isUploadImage = value;
  }

  /** 是否上传文件 : 是否上传文件，true则数据类型必须设置为string */
  private _isUploadFile: boolean;

  /** 设置：是否上传文件 */
  public get isUploadFile() {
    return this._isUploadFile;
  }

  /** 获取：是否上传文件 */
  public set isUploadFile(value: boolean) {
    this._isUploadFile = value;
  }

  /** 关联类型 : 关联类型，只针对关联属性有效 */
  private _relationshipType: EnumRelationshipType;

  /** 设置：关联类型 */
  public get relationshipType() {
    return this._relationshipType;
  }

  /** 获取：关联类型 */
  public set relationshipType(value: EnumRelationshipType) {
    this._relationshipType = value;
  }

  /** 是否持久化 : 不持久化的属性不会进行持久化操作，仅作为内存属性使用 */
  private _isPersistence: boolean;

  /** 设置：是否持久化 */
  public get isPersistence() {
    return this._isPersistence;
  }

  /** 获取：是否持久化 */
  public set isPersistence(value: boolean) {
    this._isPersistence = value;
  }

  /** 是否百分比 : 数据呈现为百分比 */
  private _isPercent: boolean;

  /** 设置：是否百分比 */
  public get isPercent() {
    return this._isPercent;
  }

  /** 获取：是否百分比 */
  public set isPercent(value: boolean) {
    this._isPercent = value;
  }

  /** 单位 : 用于编辑、详情页面中显示 */
  private _unitName: string;

  /** 设置：单位 */
  public get unitName() {
    return this._unitName;
  }

  /** 获取：单位 */
  public set unitName(value: string) {
    this._unitName = value;
  }

  /** 实体 的ID */
  private _entity_ID: string;

  /** 获取：实体 的ID */
  public get entity_ID() {
    return this._entity_ID;
  }

  /** 设置：实体 的ID */
  public set entity_ID(value: string) {
    this._entity_ID = value;
  }

  /** 实体  */
  private _entity: BEEntity;

  /** 获取：实体  */
  public get entity() {
    return this._entity;
  }

  /** 设置：实体  */
  public set entity(value: BEEntity) {
    this._entity = value;
    if (value !== null) {
      this.entity_ID = value.id;
    } else {
      this.entity_ID = '';
    }
  }

  constructor() {
    super();
    this._accessModifier = EnumAccessModifier.Public;
    this._isCalculate = false;
    this._calculateExpress = '';
    this._isStatic = false;
    this._isBusinessKey = false;
    this._isUnique = false;
    this._defaultColumnName = '';
    this._isForFront = true;
    this._isSystem = false;
    this._isAssociation = false;
    this._isUploadImage = false;
    this._isUploadFile = false;
    this._relationshipType = EnumRelationshipType.None;
    this._isPersistence = true;
    this._isPercent = false;
    this._unitName = '';
    this._entity_ID = '';
    this._entity = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEAttribute, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.accessModifier = element.accessModifier;
      this.isCalculate = element.isCalculate;
      this.calculateExpress = element.calculateExpress;
      this.isStatic = element.isStatic;
      this.isBusinessKey = element.isBusinessKey;
      this.isUnique = element.isUnique;
      this.defaultColumnName = element.defaultColumnName;
      this.isForFront = element.isForFront;
      this.isSystem = element.isSystem;
      this.isAssociation = element.isAssociation;
      this.isUploadImage = element.isUploadImage;
      this.isUploadFile = element.isUploadFile;
      this.relationshipType = element.relationshipType;
      this.isPersistence = element.isPersistence;
      this.isPercent = element.isPercent;
      this.unitName = element.unitName;
      this.entity_ID = element.entity_ID;
      if (hasReference && element.entity !== null) {
        this.entity = element.entity;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.accessModifier = json.AccessModifier as EnumAccessModifier;
    this.isCalculate = json.IsCalculate;
    this.calculateExpress = json.CalculateExpress;
    this.isStatic = json.IsStatic;
    this.isBusinessKey = json.IsBusinessKey;
    this.isUnique = json.IsUnique;
    this.defaultColumnName = json.DefaultColumnName;
    this.isForFront = json.IsForFront;
    this.isSystem = json.IsSystem;
    this.isAssociation = json.IsAssociation;
    this.isUploadImage = json.IsUploadImage;
    this.isUploadFile = json.IsUploadFile;
    this.relationshipType = json.RelationshipType as EnumRelationshipType;
    this.isPersistence = json.IsPersistence;
    this.isPercent = json.IsPercent;
    this.unitName = json.UnitName;
    this.entity_ID = json.Entity_ID;
    // if (json.Entity !== null) {
    //   this.entity = BEEntity.Create(json.Entity);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.AccessModifier = this.accessModifier;
    json.IsCalculate = this.isCalculate;
    json.CalculateExpress = this.calculateExpress;
    json.IsStatic = this.isStatic;
    json.IsBusinessKey = this.isBusinessKey;
    json.IsUnique = this.isUnique;
    json.DefaultColumnName = this.defaultColumnName;
    json.IsForFront = this.isForFront;
    json.IsSystem = this.isSystem;
    json.IsAssociation = this.isAssociation;
    json.IsUploadImage = this.isUploadImage;
    json.IsUploadFile = this.isUploadFile;
    json.RelationshipType = this.relationshipType;
    json.IsPersistence = this.isPersistence;
    json.IsPercent = this.isPercent;
    json.UnitName = this.unitName;
    json.Entity_ID = this.entity_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('代码属性', 'accessModifier', '访问修饰符', EnumDataType.Reference, this.accessModifier, true, '访问修饰符', 'EnumAccessModifier', 'PGRowEnumValue');
    context.addRow('计算属性', 'isCalculate', '是否是计算属性', EnumDataType.Bool, this.isCalculate, true, '是否是计算属性', '', '');
    context.addRow('计算属性', 'calculateExpress', '计算表达式', EnumDataType.String, this.calculateExpress, true, '计算表达式，当IsCalculate为true的时候有效', '', '');
    context.addRow('代码属性', 'isStatic', '是否是静态', EnumDataType.Bool, this.isStatic, true, '是否是静态属性', '', '');
    context.addRow('代码属性', 'isBusinessKey', '业务主键', EnumDataType.Bool, this.isBusinessKey, true, '业务主键，多个属性同时为true则会设置为联合业务主键', '', '');
    context.addRow('代码属性', 'isUnique', '是否唯一', EnumDataType.Bool, this.isUnique, true, '是否唯一，true代表属性的值必须唯一，且不能为空', '', '');
    context.addRow('代码属性', 'isForFront', '是否前端可见', EnumDataType.Bool, this.isForFront, true, '是否前端可见，false代表不对前端输出，前端不可见', '', '');
    context.addRow('代码属性', 'isUploadImage', '是否上传图片', EnumDataType.Bool, this.isUploadImage, true, '是否上传图片，true则数据类型必须设置为string', '', '');
    context.addRow('代码属性', 'isUploadFile', '是否上传文件', EnumDataType.Bool, this.isUploadFile, true, '是否上传文件，true则数据类型必须设置为string', '', '');
    context.addRow('代码属性', 'isPersistence', '是否持久化', EnumDataType.Bool, this.isPersistence, true, '不持久化的属性不会进行持久化操作，仅作为内存属性使用', '', '');
    context.addRow('代码属性', 'isPercent', '是否百分比', EnumDataType.Bool, this.isPercent, true, '数据呈现为百分比', '', '');
    context.addRow('基本属性', 'unitName', '单位', EnumDataType.String, this.unitName, true, '用于编辑、详情页面中显示', '', '');
    return context;
  }

  static Create(json: any): BEAttribute {
    const bEAttribute = new BEAttribute();
    bEAttribute.Deserialize(json);
    bEAttribute.json = json;
    return bEAttribute;
  }
}
